import { render } from "./FullScreenModalWithHeader.vue?vue&type=template&id=25c0c3ec"
import script from "./FullScreenModalWithHeader.vue?vue&type=script&lang=js"
export * from "./FullScreenModalWithHeader.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__